import { readEnv } from "../analytics/config";

/** api and exproc have no endpoint reporting them yet, so they stay unset. */
export interface StackVersions {
  web?: string;
  api?: string;
  exproc?: string;
}

/** The build this bundle was cut from; injected at deploy time. */
export function webVersion(): string | undefined {
  return readEnv("VITE_APP_VERSION");
}

/** Off unless a deployment opts in via helm, so production shows nothing by default. */
export function versionsVisible(): boolean {
  return readEnv("VITE_FOOTER_VERSIONS_ENABLED") === "true";
}

/** "web v1.4.0 · api v2.1.3". Unknown pieces are left out, not shown blank. */
export function versionLine({ web, api, exproc }: StackVersions): string {
  const parts: string[] = [];

  if (web) parts.push(`web ${tagged(web)}`);

  if (api) parts.push(`api ${tagged(api)}`);

  if (exproc) parts.push(`exproc ${tagged(exproc)}`);

  return parts.join(" · ");
}

// CI tags some builds and leaves others bare.
function tagged(version: string): string {
  return version.startsWith("v") ? version : `v${version}`;
}
